<template>
  <NuxtLayout name="standard">
    <template v-if="strapiPageData">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
      <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />

      <SSection :has-separator="false" :mobile-full="true">
        <SHeroCardSearch
          :image="heroImage"
          :title="t('landings.escapadas-list.title')"
        />
      </SSection>
      <SSection
        :has-separator="false"
        :title="t('landings.escapadas-list.subtitle')"
        title-tag="h2"
      >
        <SLinks v-bind="sLinksPropsInterface"></SLinks>
      </SSection>

      <SSpacer />
    </template>
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Types
import { type schemaType as escapadasListSchematype } from '~~/modules/api/strapi/escapadas/list/schema'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import type { propsInterface as SLinksPropsInterface } from '~~/modules/design-system/sections/s-links/s-links.vue'

// APIs
import getEscapadasList from '~~/modules/api/strapi/escapadas/list'

// Transformers
import { useToSLinks } from '~/composables/transformers/useToSLinks'

const { setHeadInfo } = useHeadInfoComposable()
const { fromStrapiEscapadasList } = useToSLinks()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

let strapiPageData: escapadasListSchematype
const NUM_COLS = 2
const heroImage =
  'https://static.er2.co/landings/La_Rioja_Adobe_Stock_266320506_1b578eead0.webp'

const sLinksPropsInterface: SLinksPropsInterface = {
  items: [],
  col: NUM_COLS,
}

const rawStrapiPageData = await getEscapadasList()

if (rawStrapiPageData.success && rawStrapiPageData.success.data) {
  strapiPageData = rawStrapiPageData.success.data
  setHeadInfo({
    title: t('landings.escapadas-list.seo-title'),
    description: t('landings.escapadas-list.description'),
    images: [
      {
        url: heroImage,
        alt: '',
      },
    ],
    robotsVisible: true,
  })

  const breadCrumbMenuStore = useMenuBreadcrumbStore()
  breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.escapadas'))

  sLinksPropsInterface.items = fromStrapiEscapadasList({
    dataIn: rawStrapiPageData.success.data,
  })
} else if (rawStrapiPageData.error) {
  showErrorPage(rawStrapiPageData.error as ApiResponseError)
}

sendConnectifPage()
</script>
